import React from 'react';

import './../styles/floor-mat-images.css';

import { useFloorMatStore } from '../stores/floor-mat-store';
import { PRODUCTS_MAP } from '../constants/product';

function FloorMatImages() {
  const selectedMatColor = useFloorMatStore(state => state.selectedMatColor);
  const selectedBorderColor = useFloorMatStore(state => state.selectedBorderColor);
  const selectedPadColor = useFloorMatStore(state => state.selectedPadColor);
  const selectedStitchingColor = useFloorMatStore(state => state.selectedStitchingColor);
  const selectedMatAreas = useFloorMatStore(state => state.selectedMatAreas);
  const baseImages = useFloorMatStore(state => state.baseImages);
  const matImages = useFloorMatStore(state => state.matImages);
  const padImages = useFloorMatStore(state => state.padImages);
  const borderImages = useFloorMatStore(state => state.borderImages);
  const stichingImages = useFloorMatStore(state => state.stichingImages);

  const productHandle = window?.conspire_product?.handle;

  return (
    <section className="floor-mat-images-container">
      {selectedMatAreas.front && (
        <div className="floor-mat-image-container">
          <img src={baseImages.front} alt="Front Floor Mat Base" />
          <img className="floor-mat-base-image" src={baseImages.front} alt="Front Floor Mat Base" />
          {productHandle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle && (
            <img src={matImages[selectedMatColor.name][0]} alt="Front Floor Mat" />
          )}
          <img src={stichingImages[selectedStitchingColor.name][1]} alt="Front Floor Mat Heel Pad Stitching" />
          <img src={padImages[selectedPadColor.name]} alt="Front Floor Mat Heel Pad" />
          <img src={borderImages[selectedBorderColor.name][0]} alt="Front Floor Mat Border" />
          <img src={stichingImages[selectedStitchingColor.name][0]} alt="Front Floor Mat Stitching" />
        </div>
      )}
      {selectedMatAreas.back && (
        <div className="floor-mat-image-container">
          <img src={baseImages.back} alt="Back Floor Mat Base" />
          <img className="floor-mat-base-image" src={baseImages.back} alt="Back Floor Mat Base" />
          {productHandle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle && (
            <img src={matImages[selectedMatColor.name][1]} alt="Back Floor Mat" />
          )}
          <img src={borderImages[selectedBorderColor.name][1]} alt="Back Floor Mat Border" />
          <img src={stichingImages[selectedStitchingColor.name][2]} alt="Back Floor Mat Stitching" />
        </div>
      )}
      {selectedMatAreas.trunk && (
        <div className="floor-mat-image-container">
          <img
            className={productHandle === PRODUCTS_MAP['carbon-fiber-floor-mats']?.handle ? 'carbon-fiber-mat-trunk-base-image' : ''}
            src={baseImages.trunk} alt="Trunk Floor Mat Base"
          />
          <img className="floor-mat-base-image" src={baseImages.trunk} alt="Trunk Floor Mat Base" />
          {productHandle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle && (
            <img src={matImages[selectedMatColor.name][2]} alt="Trunk Floor Mat" />
          )}
          <img src={borderImages[selectedBorderColor.name][2]} alt="Trunk Floor Mat Border" />
          <img src={stichingImages[selectedStitchingColor.name][3]} alt="Trunk Floor Mat Stitching" />
        </div>
      )}
      <p className="floor-mat-image-info">REPRESENTATIVE IMAGE SHOWN</p>
    </section>
  )
}

export default FloorMatImages
